import React, { useState } from 'react';
import { ChevronsLeft, ChevronsRight } from 'lucide-react';
import { MOBILE_MEDIA_QUERY } from '../../../../ui/breakpoints';
import './CommandBridge.css';

/**
 * Kommandobrücke — sticky 320px-Akkordeon-Spalte neben dem Kartenbereich
 * (Spec 2026-08-07). Einklapp-Zustand ist reiner Seiten-State: beim Öffnen
 * eines Decks ist die Brücke immer sichtbar, außer unter 900px (dort startet
 * sie zugeklappt, siehe Initial-State per matchMedia unten).
 */
export default function CommandBridge({ side = 'left', children }) {
  const [collapsed, setCollapsed] = useState(() => window.matchMedia(MOBILE_MEDIA_QUERY).matches);
  const Chevron = (side === 'left') === !collapsed ? ChevronsLeft : ChevronsRight;
  if (collapsed) {
    return (
      <aside className={`command-bridge command-bridge--collapsed command-bridge--${side}`}>
        <button
          type="button" className="command-bridge__toggle"
          title="Brücke ausklappen" aria-label="Brücke ausklappen"
          onClick={() => setCollapsed(false)}
        >
          <Chevron size={14} aria-hidden />
        </button>
      </aside>
    );
  }
  return (
    <aside className={`command-bridge command-bridge--${side}`}>
      <button
        type="button" className="command-bridge__toggle"
        title="Brücke einklappen" aria-label="Brücke einklappen"
        onClick={() => setCollapsed(true)}
      >
        <Chevron size={14} aria-hidden />
      </button>
      <div className="command-bridge__scroll">{children}</div>
    </aside>
  );
}
